import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'react-toastify/dist/ReactToastify.css';
import WaitingListForm from './latentforce-components/WaitingListForm';
import config from './latentforce-components/config/config';

import '../src/App.css';




// Terms of Service Component (add route in Routes when needed)
// const TermsOfService = () => (
//   <div className="min-h-screen p-8">
//     <iframe src="/terms-of-service.html" className="w-full h-screen border-none" title="Terms of Service" />
//   </div>
// );

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<WaitingListForm />} />
  </Routes>
);

// Session Expired Modal Component
const SessionExpiredModal = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50">
    <div className="bg-white p-6 rounded-lg shadow-xl text-center max-w-sm mx-4">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Session Expired</h2>
      <p className="text-gray-600">Please log in again to continue.</p>
    </div>
  </div>
);

// Toast Container
const ThemedToastContainer = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      toastStyle={{
        backgroundColor: '#ffffff',
        color: '#111827',
      }}
    />
  );
};

// App Content Component
const AppContent = () => {
  const [showSessionExpired, setShowSessionExpired] = useState(false);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response && error.response.status === 401) {
          setShowSessionExpired(true);
          setTimeout(() => {
            setShowSessionExpired(false);
            window.location.href = '/auth';
          }, 3000);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <Router>
      <div className="min-h-screen">
        {/* Global Toast Container */}
        <ThemedToastContainer />

        {/* Session Expired Modal */}
        {showSessionExpired && <SessionExpiredModal />}

        <AppRoutes />
      </div>
    </Router>
  );
};

// Main App Component
function App() {
  return (
    <GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID}>
      <AppContent />
    </GoogleOAuthProvider>
  );
}

export default App;